<nav class="navbar navbar-expand-md navbar-dark " [style.background-color]='getColor()'>
    <div *ngIf="this.loggedInUser.offices[0].logo !== null">
      <img height="30" width="30" class="logo-image"
        [src]="'data:image/jpeg;base64,'+ this.loggedInUser.offices[0].logo" />
    </div>
    <div *ngIf="this.loggedInUser.offices[0].logo === null">
      <img alt="" height="30" loading="lazy" src="/assets/images/courseManagementSystem.svg" width="30">
    </div>
    <a class="navbar-brand" style="color:white;cursor: pointer;margin-left: 1%;">{{navbarTitle}}</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
      <span class="navbar-toggler-icon"></span>
    </button> 
  
    <div class="collapse navbar-collapse" id="collapsibleNavbar">
      <ul class="navbar-nav ml-auto">

  
        <li class="dropdown pmd-dropdown pmd-user-info ml-auto">
          <a (click)="goToAccountPage();" style="margin-right: 10px;color: white;float: right;cursor: pointer;" class="nav-link" data-toggle="dropdown" aria-expanded="false">
            <i class="fa fa-fw fa-user"></i> Account </a>
        </li>
  
        <li class="dropdown pmd-dropdown pmd-user-info ml-auto">
          <a (click)="switchDashboard()" style="margin-right: 10px;color: white;float: right;cursor: pointer;" class="nav-link" data-toggle="dropdown" aria-expanded="false">
            <i class="fa fa-fw fa-toggle-on"></i> Switch Dashboard </a>
        </li>
  
  
        <li class="nav-item" style="float: right;">
          <a (click)="logOut()" class="nav-link" style="margin-right: 10px; color:white;float: right;cursor: pointer;">
            <i class="fa fa-sign-out" ></i> Log Out</a>
        </li>    
  
      </ul>
    </div>  
  </nav>
  
  <div class="wrapper">
    <div class="overlay" *ngIf="showSpinner">
      <div class="spinner-wrapper">
        <app-spinner></app-spinner>
      </div>
    </div>
  
    <div class="loaded-content" [class.blurred]="showSpinner">
      <ng-content></ng-content>
    </div>
  </div>




 
<div class="p-4">
  
  <div class="table-header row" [style.background-color]='getColor()' style="background-color: #343a40 ; white-space: nowrap; text-overflow: ellipsis; display: flex; flex-wrap: wrap;padding: 0.7rem; margin-left: 0%;margin-right: 0%;">
    <div class="col-md-12" style="color: rgb(248, 245, 245);">
      <mat-icon onclick="history.back()" style="margin-right: 2%; float: left; cursor: pointer; color: cornsilk; " aria-hidden="false" aria-label="Example home icon">reply_all</mat-icon>

      <span class="table-caption" style="color: rgb(250, 246, 246); font-size: 16px; font-weight: 600;" >
        Notification Settings
      </span>
      <a style="cursor:pointer;" class="float-right" (click)="addNotificationSetting();">
        <img src="/assets/images/icons/plus-circle.svg" width="25" height="25" alt="" loading="lazy">
      </a>

    </div> 
  </div>

  <div class="card">
    <div class="card-body table-responsive">
     
      <table *ngIf="notificationSettingsExist" class="table mat-elevation-z6 table-striped table-bordered table-sm row-border hover" 
      datatable [dtOptions]="userOptions" >
        <thead class="tableheader">
          <tr>
            <th>Key</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="td-height" *ngFor="let ccd of notificationSettings">
            <td class="td-height">{{ccd.key}}</td>
            <td class="td-height">{{ccd.value}}</td>
            <td class="td-height" style=" height: 2rem;">
             
              <!-- <button *ngIf="ccd.active!== null && ccd.active" type="button"
                class="btn btn-danger mr-2  btn-sm" (click)="open(confirmDeactivation);statusUpdateUserId=ccd.userId;">Deactivate</button>
              <button *ngIf="ccd.active !== null && !ccd.active" type="button"
                class="btn btn-success mr-2" (click)="open(confirmActivation);statusUpdateUserId=ccd.userId;">Activate</button>-->
              <button (click)="editNotificationSetting(ccd);" class="btn btn-info">Edit</button> 
            
            </td>
            
          </tr>    

        </tbody>
      </table>

    </div>
  </div>


</div>

<div class="p-4">
  
  <div class="table-header row" [style.background-color]='getColor()' style="background-color: #343a40 ; white-space: nowrap; text-overflow: ellipsis; display: flex; flex-wrap: wrap;padding: 0.7rem; margin-left: 0%;margin-right: 0%;">
    <div class="col-md-12" style="color: rgb(248, 245, 245);">
      <mat-icon onclick="history.back()" style="margin-right: 2%; float: left; cursor: pointer; color: cornsilk; " aria-hidden="false" aria-label="Example home icon">reply_all</mat-icon>

      <span class="table-caption" style="color: rgb(250, 246, 246); font-size: 16px; font-weight: 600;" >
        Notification Masters
      </span>
      <a style="cursor:pointer;" class="float-right" (click)="addNotificationMaster();">
        <img src="/assets/images/icons/plus-circle.svg" width="25" height="25" alt="" loading="lazy">
      </a>

    </div> 
  </div>

  <div class="card">
    <div class="card-body table-responsive">
     
      <table *ngIf="notificationSettingsExist" class="table mat-elevation-z6 table-striped table-bordered table-sm row-border hover" 
      datatable [dtOptions]="userOptions" >
        <thead class="tableheader">
          <tr>
            <th> Name</th>
            <th>Settings: Key, value</th>
            <th>Type</th>
            <th>From Address</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="td-height" *ngFor="let ccd of notificationMasters">
            <td class="td-height">{{ccd.name}}</td>
            <td class="td-height">{{ccd.fkNotificationSettingKey}}, {{ccd.fkNotificationSettingValue}}</td>
            <td class="td-height">{{ccd.type}}</td>
            <td class="td-height">{{ccd.fromAddress}}</td>
            <td class="td-height" style=" height: 2rem;">
             
              <!-- <button *ngIf="ccd.active!== null && ccd.active" type="button"
                class="btn btn-danger mr-2  btn-sm" (click)="open(confirmDeactivation);statusUpdateUserId=ccd.userId;">Deactivate</button>
              <button *ngIf="ccd.active !== null && !ccd.active" type="button"
                class="btn btn-success mr-2" (click)="open(confirmActivation);statusUpdateUserId=ccd.userId;">Activate</button>-->
              <button (click)="editNotificationMaster(ccd);" class="btn btn-info">Edit</button> 
            
            </td>
            
          </tr>    

        </tbody>
      </table>

    </div>
  </div>


</div>

<div class="p-4">
  
  <div class="table-header row" [style.background-color]='getColor()' style="background-color: #343a40 ; white-space: nowrap; text-overflow: ellipsis; display: flex; flex-wrap: wrap;padding: 0.7rem; margin-left: 0%;margin-right: 0%;">
    <div class="col-md-12" style="color: rgb(248, 245, 245);">
      <mat-icon onclick="history.back()" style="margin-right: 2%; float: left; cursor: pointer; color: cornsilk; " aria-hidden="false" aria-label="Example home icon">reply_all</mat-icon>

      <span class="table-caption" style="color: rgb(250, 246, 246); font-size: 16px; font-weight: 600;" >
        Notification History
      </span>
      <!-- <a style="cursor:pointer;" class="float-right" (click)="addNotificationMaster();">
        <img src="/assets/images/icons/plus-circle.svg" width="25" height="25" alt="" loading="lazy">
      </a> -->

    </div> 
  </div>

  <div class="card">
    <div class="card-body table-responsive">
     
      <table *ngIf="notificationSettingsExist" class="table mat-elevation-z6 table-striped table-bordered table-sm row-border hover" 
      datatable [dtOptions]="userOptions" >
        <thead class="tableheader">
          <tr>
            <th> From</th>
            <th>To</th>
            <th> Subject</th>
            <th>Timestamp</th>
            <th>Success status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="td-height" *ngFor="let ccd of notificationActuals">
            <td class="td-height">{{ccd.fromAddress}}</td>
            <td class="td-height">{{ccd.toAddress}}</td>
            <td class="td-height">{{ccd.messageSubject}}</td>
            <td class="td-height">{{ccd.timestamp}}</td>
            <td class="td-height">{{ccd.notificationSuccessStatus}}</td>
            <td class="td-height" style=" height: 2rem;">
             
              <!-- <button *ngIf="ccd.active!== null && ccd.active" type="button"
                class="btn btn-danger mr-2  btn-sm" (click)="open(confirmDeactivation);statusUpdateUserId=ccd.userId;">Deactivate</button>
              <button *ngIf="ccd.active !== null && !ccd.active" type="button"
                class="btn btn-success mr-2" (click)="open(confirmActivation);statusUpdateUserId=ccd.userId;">Activate</button>-->
              <button class="btn btn-info">View</button> 
            
            </td>
            
          </tr>    

        </tbody>
      </table>

    </div>
  </div>


</div>

  <!-- <ng-template #confirmActivation let-modal>
    <div class="modal-header">
      <h4 class="modal-title" style="font-weight: bold;" id="modal-basic-title">Confirmation</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      Are you sure to activate user ?
    </div> 
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="modal.dismiss('Cross click')">No</button>
      <button type="button" class="btn btn-success" (click)="statusUpdate();modal.dismiss('Cross click')">Activate</button>
    </div>
  </ng-template> 
  
  
  <ng-template #confirmDeactivation let-modal>
    <div class="modal-header">
      <h4 class="modal-title" style="font-weight: bold;" id="modal-basic-title">Confirmation</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      Are you sure to deactivate user ?
    </div> 
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="modal.dismiss('Cross click')">No</button>
      <button type="button" class="btn btn-success" (click)="statusUpdate();modal.dismiss('Cross click')">Deactivate</button>
    </div>
  </ng-template> -->